<template>
  <div class="flex-row" style="flex-wrap: wrap">
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="ac-input-header">
          Legal Name
        </div>
        <SACInput
          field="partnerName"
          placeholder="Enter Legal Name"
          :value="partnerName"
          :error="errorObj.partnerNameErr"
          :change="onChange"
          :disable="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Display Name (in-app)
        </div>
        <SACInput
          field="displayName"
          placeholder="Enter Display Name"
          :value="displayName"
          :error="errorObj.displayNameErr"
          :change="onChange"
          :disable="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Main Website
        </div>
        <SACInput
          field="website"
          placeholder="Enter Website"
          :value="website"
          :error="errorObj.websiteErr"
          :change="onChange"
          :disable="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-input-container flex-row mb-3">
        <div style="width: 500px">
          <div class="ac-input-header">
            Phone (123-456-7890)
          </div>
          <SACInput
            field="phone"
            placeholder="Enter Phone"
            :value="phone"
            :change="onChange"
            :error="errorObj.phoneErr"
            :disable="adminRole !== 'admin'"
          />
        </div>
        <div class="ml-4">
          <div class="ac-input-header">
            ext.
          </div>
          <SACInput
            field="phoneCountry"
            placeholder="####"
            :value="phoneCountry"
            :error="errorObj.phoneCoErr"
            :change="onChange"
            :disable="adminRole !== 'admin'"
          />
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="ac-input-header">
          Support Contact Email
        </div>
        <SACInput
          field="supportEmail"
          placeholder="Enter Email"
          :value="supportEmail"
          :error="errorObj.supportEmailErr"
          :change="onChange"
          :disable="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-input-container flex-row">
        <div>
          <div class="ac-input-header">
            Support Contact Phone
          </div>
          <SACInput
            style="width: 400px"
            field="supportPhone"
            placeholder="123-456-7890"
            :value="supportPhone"
            :error="errorObj.supportPhoneErr"
            :change="onChange"
            :disable="adminRole !== 'admin'"
          />
        </div>
        <div class="ml-4">
          <div class="ac-input-header">
            ext.
          </div>
          <SACInput
            field="supportPhoneCo"
            placeholder="####"
            :value="supportPhoneCo"
            :error="errorObj.supportPhoneCoErr"
            :change="onChange"
            :disable="adminRole !== 'admin'"
          />
        </div>
      </div>
      <div
        v-if="change"
        class="sac__font-16 n40"
        style="max-width: 500px"
      >
        Contacts for specific trades can be set in the dashboard under
        <a @click="change('request')" @keydown="change('request')">Service Requests</a>. Contacts for business matters can be set
        under <a @click="change('contact')" @keydown="change('contact')">Partner Contacts</a>.
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACInput from '@shared/components/sac/SACInput.vue';

export default {
  name: 'PartnerInfo',
  components: {
    SACInput,
  },
  mixins: [partnerSettingsMixin],
  props: {
    partnerName: String,
    displayName: String,
    website: String,
    phone: String,
    phoneCountry: String,
    supportPhone: String,
    supportPhoneCo: String,
    supportEmail: String,
    onChange: Function,
    change: Function,
    errorObj: Object,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.ac-row-container {
  display: flex;
  max-width: 500px;

  .ac-input-container {
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
